// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__BKnDt","sm":"Divider_sm__Cc3oZ","lg":"Divider_lg__Snb1i"};